import { getPlayerId } from '../controllers/stats'
import isLocalhost from './isLocalhost'
import settings from '../controllers/settings'

async function checkMigration(): Promise<boolean> {
	// Check if the player is already on puzzlist.com. If so, do nothing.
	const puzzlist = window.location.href.includes('puzzlist.com')
	if (puzzlist || isLocalhost()) return false

	// Check if we have a flag to disable migration
	if (window.location.search.includes('migrate=0')) return false

	const playerId = getPlayerId()

	const stats = localStorage.getItem('daily5_stats') // e.g. {"p":11,"sk":1,"b":1,"l":416,"s":41,"dst":[1,1,2,3,4],"bt":25}
	const statsObj = stats ? JSON.parse(stats) : null
	const hasPlayed = statsObj && statsObj.p >= 1 // Check if the player has played at least one game

	// Redirect to puzzlist.com
	// If they have played before, we send through their player ID and a flag to indicate whether to show the clock
	const url = `https://puzzlist.com/onewordsearch/`
	if (hasPlayed)
		window.location.href = `${url}?pid=${playerId}&clock=${settings.getShowClock() ? '1' : '0'}`
	else window.location.href = url

	return true
}

export default checkMigration
